"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = FileTxt;
var _FileTxt = require("@adobe/react-spectrum-workflow/dist/FileTxt.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function FileTxt(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_FileTxt.A4uFileTxt, null));
}